/** Row hover — no per-row blur (blur lives on panel only, one compositing layer). */
export const MENU_ITEM_HOVER_SURFACE = [
  'hover:bg-[rgba(242,242,242,0.95)] dark:hover:bg-[rgba(32,42,62,0.9)]',
  'focus-visible:bg-[rgba(242,242,242,0.95)] dark:focus-visible:bg-[rgba(32,42,62,0.9)]',
].join(' ');

/** Forced Hover / Focus — Figma state variants (5302:20800) */
export const MENU_ITEM_FORCED_ACTIVE_SURFACE =
  'bg-[rgba(242,242,242,0.95)] dark:bg-[rgba(32,42,62,0.9)]';

export const MENU_ITEM_ROW_BASE = [
  'flex w-full min-w-[16.25rem] max-w-full items-center overflow-hidden',
  'text-left transition-colors',
  'focus-visible:outline-none',
].join(' ');

export const MENU_ITEM_SIZE_CLASS = {
  medium: 'gap-4 px-4 py-2',
  small: 'gap-2 p-2',
};

export const MENU_ITEM_CONTENT_GAP = {
  medium: 'gap-2',
  small: 'gap-1',
};

export const MENU_ITEM_LABEL_CLASS = {
  medium: 'text-sm font-medium leading-5',
  small: 'text-xs font-medium leading-5',
};

export const MENU_ITEM_DESCRIPTION_CLASS = 'text-xs font-medium leading-5';

export const MENU_ITEM_ICON_SIZE = {
  medium: 24,
  small: 16,
};

/**
 * Figma Menu-items avatar (8426:37476) — `size-[24px]` en M y en contact list.
 * Mapea a Avatar `md` (h-6 w-6 = 24px).
 */
export const MENU_ITEM_AVATAR_SIZE = {
  medium: 'md',
  small: 'md',
};

export const MENU_ITEM_CHECKBOX_SIZE = {
  medium: 'medium',
  small: 'small',
};

/** Figma: Caption Bold XS 10px, semibold, centrado en círculo 24px; border primary lighter */
export const MENU_ITEM_AVATAR_DEFAULT_CLASS = [
  '!h-6 !w-6 !min-h-6 !min-w-6 shrink-0 rounded-full',
  'border-[#80AFFF] bg-[#2173FF] text-white dark:border-blue-400 dark:bg-blue-600',
  '[&>span]:flex [&>span]:size-full [&>span]:items-center [&>span]:justify-center',
  '[&>span]:text-[10px] [&>span]:font-semibold [&>span]:leading-none',
].join(' ');

export const MENU_ITEM_CLOSE_PADDING = {
  medium: 'rounded-lg p-2',
  small: 'rounded p-1',
};

export const MENU_ITEM_CLOSE_ICON_SIZE = {
  medium: 24,
  small: 16,
};

export const MENU_ITEM_LOADING_SKELETON_CLASS =
  'min-h-5 min-w-0 h-full flex-1 rounded-2xl';

/** Menu Card shell — Figma 13483:1642 / 8426:37662 */
export const MENU_PANEL_BASE = [
  'overflow-hidden rounded-xl',
  'border border-edge shadow-[0px_4px_12px_rgba(0,0,0,0.08)]',
  'backdrop-blur-[8px] bg-[rgba(255,255,255,0.92)] dark:bg-[rgba(20,27,42,0.85)]',
  'dark:shadow-[0px_4px_12px_rgba(0,0,0,0.35)]',
].join(' ');

/** Figma 8426:37662 — list height 240px */
export const MENU_PANEL_DEFAULT_MAX_HEIGHT_CLASS = 'max-h-[240px]';

/** Gutter outside scroll viewport — Figma 8426:37669: ~8px inset (top, bottom, right). */
export const MENU_PANEL_SCROLL_GUTTER_CLASS = 'py-2 pr-2';

/**
 * Scroll viewport — `scrollbar-aimsos-auto-sm` (4px). Sits inside {@link MENU_PANEL_SCROLL_GUTTER_CLASS}
 * so the thumb is not flush with the panel border (WebKit paints scrollbar on the scroller edge).
 */
export const MENU_PANEL_SCROLL_VIEWPORT_CLASS = [
  'min-h-0 overflow-y-auto overflow-x-hidden',
  'scrollbar-aimsos-auto-sm',
].join(' ');

/** Static body when scroll is disabled */
export const MENU_PANEL_STATIC_BODY_CLASS = 'flex flex-col py-2';
